import {Vue} from 'vue-property-decorator';
import appconst from './appconst'

/**
 * abp基类
 */
export default class AbpBase extends Vue {
  /**
   * 国际化
   */
  L(value: string, source?: string, ...argus: string[]): string {
    if (source) {
      return window.abp.localization.localize(value, source, argus);
    } else {
      return window.abp.localization.localize(value, appconst.localization.defaultLocalizationSourceName, argus);
    }
  }
  
  /**
   * 是否有权限
   */
  hasPermission(permissionName: string) {
    return window.abp.auth.hasPermission(permissionName);
  }
  
  /**
   * 是否有权限
   */
  hasAnyOfPermissions(...argus: string[]) {
    return window.abp.auth.hasAnyOfPermissions(...argus);
  }
  
  /**
   * 是否有权限
   */
  hasAllOfPermissions(...argus: string[]) {
    return window.abp.auth.hasAllOfPermissions(...argus);
  }
}
